import { apolloClient } from '@/setup/apollo-setup';
import { error } from '@/utils/notification';

import { GET_CLASSROOM } from '@/queries/modules/class-room/classRoom';
import { GET_CLASSROOM_STATS } from '@/queries/modules/class-room/classRoomStats';

export async function getClassroom(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSROOM,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const { data, errors } = result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.classRoom;
    }

    if (result || data) {
      context.commit('setClassRoom', data.getClassRoom);
      context.commit('setSuccess', null);
      return data.getClassRoom
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

/*
export async function getClassroomStudentInEachUnitStats(context, payload) {

}
*/

export async function getClassroomStats(context, payload) {

  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSROOM_STATS,
        variables: payload,
        fetchPolicy: "no-cache",
        context: { clientName: 'Prisma2' }
      });

    const { data } = result;

    if (result || data) {
      // context.commit('setClassroom', data.getClassroomStats);

      context.commit('setSuccess', null);
      const success = true;
      const error = null;
      return { status: { success, error }, data: data.getClassroomStats };
    }

    throw new Error("No classroom state data");

  } catch (e) {
    context.commit('setError', error(e));
    return { status: { success: false, error: true, message: "", full: e } };
  }
}
